import { Capacitor, registerPlugin } from "@capacitor/core";
import { apiClient, getStoredTokens } from "@/lib/api";

/* Pont vers l'écran d'alerte natif Android (RingService / AlertActivity).
   Sur iOS et web, toutes les méthodes sont des no-op sûrs. */
const IncomingAlert = Capacitor.getPlatform() === "android" ? registerPlugin("IncomingAlert") : null;

/** Donne au natif l'URL API + le jeton pour couper une alerte côté serveur depuis l'écran natif. */
export async function configureNativeAlerts() {
  if (!IncomingAlert) return;
  try {
    const tokens = getStoredTokens();
    const token = tokens?.access_token || tokens?.session_token || "";
    await IncomingAlert.configure({ apiUrl: process.env.REACT_APP_BACKEND_URL, token });
  } catch (e) { /* natif indisponible */ }
}

/** Action choisie sur l'écran natif (« Voir la commande » / « J'y vais ») à traiter côté web. */
export async function consumeNativeLaunchAction() {
  if (!IncomingAlert) return null;
  try {
    const r = await IncomingAlert.getLaunchAction();
    return r && r.alert_id ? r : null;
  } catch (e) { return null; }
}

export async function stopNativeRinging(alertId) {
  if (!IncomingAlert) return;
  try { await IncomingAlert.stopRinging({ alertId }); } catch (e) { /* no-op */ }
}

/** Android 14+ : l'affichage plein écran doit être autorisé une fois par l'utilisateur. */
export async function canShowFullScreenAlerts() {
  if (!IncomingAlert) return true;
  try { return (await IncomingAlert.canUseFullScreenIntent()).value !== false; } catch (e) { return true; }
}

export async function openFullScreenAlertSettings() {
  if (!IncomingAlert) return;
  try { await IncomingAlert.openFullScreenIntentSettings(); } catch (e) { /* no-op */ }
}

export async function dismissAlert(alertId) {
  await stopNativeRinging(alertId);
  try { await apiClient.post(`/alerts/${alertId}/dismiss`); } catch (e) { /* déjà terminée */ }
}
